// KeyboardHelp — `?` tuşuyla açılan klavye kısayolları cheatsheet modalı.
// Kullanım: <KeyboardHelp open={open} onClose={...} />
import React from 'react';

const SHORTCUTS = [
  {
    group: 'Genel',
    items: [
      { keys: ['Ctrl', 'K'], desc: 'Komut paletini aç (sayfa/müşteri/stok ara)' },
      { keys: ['Ctrl', 'Cmd', 'K'], desc: 'Mac: Komut paleti' },
      { keys: ['?'], desc: 'Bu yardım ekranını aç' },
      { keys: ['Esc'], desc: 'Açık modal/dropdown\'u kapat' },
    ],
  },
  {
    group: 'Komut Paleti',
    items: [
      { keys: ['↑'], desc: 'Üst sonuca git' },
      { keys: ['↓'], desc: 'Alt sonuca git' },
      { keys: ['Enter'], desc: 'Seçili sonucu aç' },
      { keys: ['Esc'], desc: 'Paletten çık' },
    ],
  },
  {
    group: 'Mesajlar / Aktivite',
    items: [
      { keys: ['Ctrl', 'Enter'], desc: 'Yorum/mesaj gönder (composer içinde)' },
      { keys: ['Enter'], desc: 'Mesajlarda yeni satır yerine gönder' },
      { keys: ['Shift', 'Enter'], desc: 'Mesajlarda yeni satır' },
    ],
  },
  {
    group: 'CRM Pipeline (Kanban)',
    items: [
      { keys: ['Mouse'], desc: 'Kartı sürükle bırak ile aşama değiştir' },
      { keys: ['Click'], desc: 'Kart üzerinde tek tık → detay modalı' },
    ],
  },
  {
    group: 'Listeler / Tablolar',
    items: [
      { keys: ['Ctrl', 'F'], desc: 'Tarayıcı arama (sayfa içi)' },
      { keys: ['Click'], desc: 'Satır tıklama → detay açma' },
    ],
  },
];

export default function KeyboardHelp({ open, onClose }) {
  if (!open) return null;
  return (
    <div style={S.overlay} onClick={onClose}>
      <div style={S.modal} onClick={(e) => e.stopPropagation()}>
        <div style={S.header}>
          <div>
            <div style={S.title}>Klavye Kısayolları</div>
            <div style={S.sub}>Daha hızlı çalışmak için</div>
          </div>
          <button onClick={onClose} style={S.closeBtn} aria-label="Kapat">×</button>
        </div>

        <div style={S.body}>
          {SHORTCUTS.map(g => (
            <div key={g.group} style={S.group}>
              <div style={S.groupTitle}>{g.group}</div>
              <div>
                {g.items.map((it, i) => (
                  <div key={i} style={S.row}>
                    <div style={S.keys}>
                      {it.keys.map((k, ki) => (
                        <React.Fragment key={ki}>
                          {ki > 0 && <span style={S.plus}>+</span>}
                          <kbd style={S.kbd}>{k}</kbd>
                        </React.Fragment>
                      ))}
                    </div>
                    <div style={S.desc}>{it.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={S.footer}>
          <span style={S.hint}>Tekrar bu ekranı açmak için <kbd style={S.kbd}>?</kbd> tuşuna bas</span>
        </div>
      </div>
    </div>
  );
}

const S = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 9100,
    background: 'rgba(0,0,0,0.45)',
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    padding: 16,
    animation: 'kbdhelp-fade 0.15s ease-out',
  },
  modal: {
    width: '100%', maxWidth: 620, maxHeight: '85vh',
    background: 'var(--bg-secondary)',
    border: '1px solid var(--border-secondary)',
    borderRadius: 'var(--r-xl)',
    boxShadow: 'var(--shadow-lg)',
    display: 'flex', flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 18px',
    borderBottom: '1px solid var(--border-secondary)',
  },
  title: {
    fontSize: 'var(--text-lg)', fontWeight: 700,
    color: 'var(--text-primary)',
  },
  sub: {
    fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)',
    marginTop: 2,
  },
  closeBtn: {
    width: 28, height: 28,
    border: 'none', background: 'var(--bg-tertiary)',
    color: 'var(--text-secondary)',
    borderRadius: '50%', cursor: 'pointer',
    fontSize: 20, lineHeight: 1,
  },
  body: {
    flex: 1, overflow: 'auto',
    padding: 16,
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: 18,
  },
  group: {},
  groupTitle: {
    fontSize: '0.66rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: 'var(--text-tertiary)',
    marginBottom: 8,
  },
  row: {
    display: 'flex', alignItems: 'center', gap: 12,
    padding: '6px 0',
    borderBottom: '1px solid var(--border-secondary)',
  },
  keys: { display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0, minWidth: 100 },
  plus: { fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' },
  kbd: {
    fontFamily: 'JetBrains Mono, monospace',
    fontSize: '0.7rem',
    padding: '2px 7px',
    border: '1px solid var(--border-input)',
    borderBottom: '2px solid var(--border-input)',
    borderRadius: 'var(--r-xs)',
    background: 'var(--bg-card)',
    color: 'var(--text-primary)',
    fontWeight: 600,
    minWidth: 18, textAlign: 'center',
  },
  desc: {
    fontSize: 'var(--text-sm)',
    color: 'var(--text-secondary)',
    flex: 1,
  },
  footer: {
    padding: '10px 18px',
    borderTop: '1px solid var(--border-secondary)',
    background: 'var(--bg-card)',
    textAlign: 'center',
  },
  hint: {
    fontSize: 'var(--text-xs)',
    color: 'var(--text-tertiary)',
  },
};

if (typeof document !== 'undefined' && !document.getElementById('kbdhelp-keyframes')) {
  const s = document.createElement('style');
  s.id = 'kbdhelp-keyframes';
  s.textContent = '@keyframes kbdhelp-fade { from { opacity: 0; } to { opacity: 1; } }';
  document.head.appendChild(s);
}
